import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

@ngCore.Component({
  imports: [ds.overlay.attached.Component],
  selector: 'atn-assistant-switcher',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
/**
 * Component for switching between available assistants
 */
export class Component {
  /**
   * Controls whether overlay (for switching assistants) is currently visible
   */
  public readonly overlayIsOpenSg = ngCore.signal(false)

  /**
   * ID of the currently selected agent.
   */
  public readonly selectedAgentId =
    ngCore.model<ents.core.agent.Agent.Id | undefined>(undefined, {
      alias: 'selectedAgentId',
    })
  /**
   * List of available assistants for selection
   *
   * @see {@link ents.core.agent.Display}
   */
  public readonly assistantDisplaysSg = ngCore.input<
    readonly ents.core.agent.Display[]
  >([], {
    alias: 'assistants',
  })

  /** Whether the switcher is disabled */
  public readonly disabledSg = ngCore.input<boolean>(false, {
    alias: 'disabled',
  })

  /**
   * The currently selected assistant display, computed from the list of available assistants
   *
   * @see {@link ents.core.agent.Display}
   */
  public readonly selectedAssistantDisplaySg = ngCore.computed(
    (
      assistantDisplays = this.assistantDisplaysSg(),
      selectedAgentId = this.selectedAgentId(),
    ) =>
      assistantDisplays.find(
        assistantDisplay => assistantDisplay.id === selectedAgentId,
      ),
  )
}
